import { useAppSelector } from "hooks";

export const useUser = () => {
  const { userData } = useAppSelector((state) => state.slidGlobal);

  const isSlidAccount = userData?.email?.endsWith("@slid.cc");

  return { userData, isSlidAccount };
};
